/**
 * SAP / HANA base URLs. Hardcoded for the single client. The wp-admin setting
 * `al_windows_api_base` (exposed on window.AL_WINDOWS_CONFIG.apiBase) can
 * override this at runtime for staging shakeouts without a rebuild.
 */

export const API_BASE_PROD =
  'https://alwindowsecommerceym9xpdn17g.ap1.hana.ondemand.com/services/api'

export const API_BASE_NONPROD =
  'https://alwindowsecommercesf6zj0lly7.ap1.hana.ondemand.com/services/api'

declare global {
  interface Window {
    AL_WINDOWS_CONFIG?: {
      apiBase?: string
      debug?: boolean
      restUrl?: string
    }
  }
}

export function resolveApiBase(): string {
  const override = typeof window !== 'undefined' ? window.AL_WINDOWS_CONFIG?.apiBase : ''
  if (override) return override
  // Default: production. The non-prod base is reachable via the admin override.
  return API_BASE_PROD
}

export function isDebug(): boolean {
  return typeof window !== 'undefined' && Boolean(window.AL_WINDOWS_CONFIG?.debug)
}
